import Wait from './view/animation/Wait';
import AddToHand from './view/animation/AddToHand';
import RemoveFromHand from './view/animation/RemoveFromHand';
import Attack from './view/animation/Attack';
import Damage from './view/animation/Damage';
import BlockDamage from './view/animation/BlockDamage';
import NewIntent from './view/animation/NewIntent';
import Intent from './view/animation/Intent';
import Status from './view/animation/Status';
import Block from './view/animation/Block';
import Heal from './view/animation/Heal';
import Corruption from './view/animation/Corruption';
import Shuffle from './view/animation/Shuffle';
import Cast from './view/animation/Cast';
import Combination from './view/animation/Combination';
import TimeDown from './view/animation/TimeDown';
import LevelUp from './view/animation/LevelUp';
import LevelBreak from './view/animation/LevelBreak';
import Levelstep from './view/animation/Levelstep';
import Brew from './view/animation/Brew';
import Gold from './view/animation/Gold';
import Buy from './view/animation/Buy';
import Drink from './view/animation/Drink';
import Blink from './view/animation/Blink';
import Dialog from './view/animation/Dialog';
import Slots from './view/animation/Slots';
import Momentum from './view/animation/Momentum';
import Quake from './view/animation/Quake';
import Climax from './view/animation/Climax';
import EnemyDie from './view/animation/EnemyDie';
import MinionsDie from './view/animation/MinionsDie';

export default class Sequencer {

	constructor (master, dispatch) {

		this.master = master;
		this.queue = [];
		this.current = null;
		this.dispatch = dispatch;
		this.logs = [];
		this.idleTimeout = null;
		/*this.extraturns = [0, 0];
		this.currentturn = -1;*/
	}

	add (event) {

		if (this.current)
			this.queue.push(event);
		else
			this.read(event);
	}

	next () {

		this.current = null;
		if (this.queue.length > 0)
			this.read(this.queue.shift());
	}

	read (event) {

		if (this.master.stopped)
			return;
		let n = event.n;
		this.logs.push(n);
		if (event.callback)
			event.callback();
		var anim = this.notifToAnim(n);
		if (anim) {
			if (anim.sync)
				this.current = anim;
			if (!anim.before)
				this.dispatch(n);
			anim.start(() => {
				if (anim.before)
					this.dispatch(n);
				this.next();
			});
		} else {
			this.dispatch(n);
			this.next();
		}

		/*var anim = this.notifToAnim(n);
		if (anim) {
			if (anim.sync)
				this.current = anim;
			if (anim.before) {
				anim.start(() => {
					this.dispatch(n);
					this.next();
				});
			}
			else {
				this.dispatch(n);
				this.resume = () => {
					delete this.resume;
					anim.start(() => {
						this.next();
					});
				};
			}
		} else {
			this.dispatch(n);
			this.next();
		}*/
	}

	update () {

		if (!this.current.sync)
			this.next();
	}

	animDialog (type) {

		if (!this.master.run || !this.master.run.room || this.master.run.room.fight)
			return null;

		let champion = this.master.run.champion.model.key;
    	let entities = this.master.run.room.entities.map((entity, i) => Object.assign({key: i}, entity)).filter(entity => entity.dialogs && ((entity.dialogs[0] && entity.dialogs[0][type]) || (entity.dialogs[champion] && entity.dialogs[champion][type])));
    	if (entities.length === 0)
    		return null;
    	const entity = entities[Math.floor(Math.random() * entities.length)];
    	let dialogs = [];
    	if (entity.dialogs[0] && entity.dialogs[0][type])
    		dialogs.push(...entity.dialogs[0][type])
    	if (entity.dialogs[champion] && entity.dialogs[champion][type])
    		dialogs.push(...entity.dialogs[champion][type])
    	if (dialogs.length === 0)
    		return;
    	const dialog = dialogs[Math.floor(Math.random() * dialogs.length)];
    	return new Dialog(this.master, entity, dialog);
	}

	resetIdleTimeout() {
	    if (this.idleTimeout) {
	        clearTimeout(this.idleTimeout);
	        this.idleTimeout = null; 
	    }

	    this.idleStart = Date.now(); // Store the start time

	    const delay = 15000 + Math.random() * 10000;

	    this.idleTimeout = setTimeout(() => {
	        const elapsed = Date.now() - this.idleStart;
	        if (elapsed >= 15000) {
	            this.handleIdle();
	        }
	    }, delay);
	}

	handleIdle() {
	    // Logic for handling idling
	    this.master.run.notify("idling", this.master.run);

	    // Optionally set up repeated detection for long-term idling
		this.resetIdleTimeout();
	}

	notifToAnim (n) {

		this.resetIdleTimeout();

	  switch(n.type) {
	    case "gamestate": return;
	    case "wait":
	    	return new Wait(this.master, n.data[1]);
	    case "startfight":
	    	return new Wait(this.master, 200);
	    case "levelup":
	    	return n.data[2] ? new LevelBreak(this.master) : new LevelUp(this.master);
	    case "gainexp": {
	    	if (n.data[0].expbar < n.data[0].threshold)
	    		return new Levelstep(this.master);
	    	return null;
	    }
	    case "cast.before": {
	    	if (n.data[0].type === "attack" && !n.data[0].model.noanim)
	    		return new Attack(this.master, "player");
	    	return null;
	    	//return new Wait(this.master, 200);
	    }
	    case "cast": {
	    	return null;
	    	//return new Wait(this.master, 200);
	    }
		case "skill.before":
		case "companionact.before": {
	    	return new Attack(this.master, "companion");
	    }
	    case "intent": {
	    	return new NewIntent(this.master, n.data[0].id.no);
	    }
	    case "shufflecard":
	    	return new Shuffle(this.master, n.data[0].model, n.data[1].type);
	    case "autocast":
	    	return new Cast(this.master, n.data[0].model);
	    case "blockgain": {
	    	return new Block(this.master, n.data[0].id === "player" ? "player" : n.data[0].id.no);
	    }
	    case "blockdamage": {
	    	return new BlockDamage(this.master, n.data[0].id === "player" ? "player" : n.data[0].id.no);
	    }
	    case "lifegain": {
	    	return new Heal(this.master, n.data[0].id === "player" || n.data[0].id === "champion" ? "player" : n.data[0].id.no);
	    }
	    case "gaincorruption": {
	    	return new Corruption(this.master, "player");
	    }
	    case "applystatus": {
	    	return new Status(this.master, n.data[0].id === "player" ? "player" : n.data[0].id.no, n.data[1]);
	    }
	    case "enemyact.before": {
	    	let intent = new Intent(this.master, n.data[0].id.no);
	    	if (n.data[1] === "attack")
	    		return new Combination(intent, new Attack(this.master, n.data[0].id.no));
	    	return intent;
	    	//return new Wait(this.master, 200);
	    }
	    case "enemyact": {
	    	if (n.data[1] === "attack")
	    		return new Wait(this.master, 300);
	    	return new Wait(this.master, 300);
	    	//return new Wait(this.master, 200);
	    }
	    case "attack.before": {
	    	return new Attack(this.master, n.data[0].no);
	    }
	    case "lifeloss": {
	    	return new Damage(this.master, n.data[0].id === "champion" ? "player" : n.data[0].id.no, n.data[2]);
	    }/*
	    case "nodamage": {
	    	return new Damage(this.master, n.data[0], 0);
	    }*/
	    case "enemydie": {
	    	return new EnemyDie(this.master, n.data[0].id.no);
	    }
	    case "minionsdie": {
	    	return new MinionsDie(this.master, n.data[0]);
	    }
	    case "movecard.before": {
	    	if (n.data[1]?.type === "hand") {
		    	let card = n.data[0];
		    	if (card)
		    		return new RemoveFromHand(this.master, n.data[0].id.no);
		    }
		    break;
		}
	    case "movecard": {
	    	if (n.data[2]?.type === "hand") {
		    	let card = n.data[0];
		    	if (card)
		    		return new AddToHand(this.master, n.data[0].id.no);
		    }
		    /*if (n.data[1] && n.data[1].type === "hand") {
		    	let card = this.master.state.model.find(n.data[0]);
		    	if (card)
		    		return new RemoveFromHand(this.master, n.data[0].no);
		    }*/
		    /*if (n.data[2] && n.data[2].type === "court") {
		    	return new Wait(this.master, 1000);
		    }*/
	    	break; }
	    case "timedown": {
	    	return new TimeDown(this.master);
	    }
	    case "brewpotion": {
	    	return new Brew(this.master);
	    }
	    case "gaingold": {
	    	return new Gold(this.master);
	    }
	    case "losegold": {
	    	return new Buy(this.master);
	    }
	    case "collect": {
	    	if (n.data[0].type === "shards")
	    		return new Blink(this.master);
	    	break;
	    }
	    case "drinkpotion": {
	    	return new Drink(this.master);
	    }
	    case "shopbuy": {
	    	return this.animDialog("buy");
	    }
	    case "idling": {
	    	return this.animDialog("idle");
	    }
	    case "runslots": {
	    	return new Slots(this.master, n.data[1]);
	    }
	    case "initroom":
	    case "enterroom": {
	    	return this.animDialog("enter");
	    }
	    case "newfountain": {
	    	if (n.data[1].champion.potions.some(potion =>
	    		(potion.fountain || potion.activefountain) &&
	    		(!potion.requirescurse || n.data[1].champion.curses.length > 0)
	    	))
	    		return new Dialog(this.master, "player", "I could use a potion…");
	    	break;
	    }
	    case "newshop": {
	    	const shop = n.data[0];
	    	const run = n.data[1];
	    	const hasContextPotion =
	    		(shop.mezuri && run.champion.potions.some(potion => potion.mezurishop)) ||
	    		(run.room?.type === "menagerie" && run.champion.potions.some(potion => potion.menagerie)) ||
	    		run.champion.potions.some(potion => potion.shop);
	    	if (hasContextPotion)
	    		return new Dialog(this.master, "player", "I could use a potion…");
	    	break;
	    }
	    case "generatetreasure": {
	    	if (n.data[1]?.type === "relic" && n.data[0].run.champion.potions.some(potion => potion.relic))
	    		return new Dialog(this.master, "player", "I could use a potion…");
	    	break;
	    }
	    case "roomcollectable": {
	    	if (n.data[1] === "relic" && n.data[0].run.champion.potions.some(potion => potion.relic))
	    		return new Dialog(this.master, "player", "I could use a potion…");
	    	break;
	    }
		case "animation": {
			switch (n.data[1]) {
			case "momentum": return new Momentum(this.master);
			case "bumper-momentum": return new Momentum(this.master, "companion", "https://moa-pull.b-cdn.net/assets/companions/Spinelle/Bumper/225d2a6e-0cdd-4082-82c2-e8d196700463.png");
			case "quake": return new Quake(this.master, n.data[3]);
			//case "climax": return new Climax(this.master, n.data[3]);
			default: return null;
			}
	    }
	    default: return null;
	    }
	}
}
